<template>
  <div>
    <HeaderLayout></HeaderLayout>
    <div>
      <HomeComponent v-if="navIndex==1"></HomeComponent>
      <MessageList v-if="navIndex==2"></MessageList>
      <GuideList v-if="navIndex==3"></GuideList>
      <PoliciesRegulations v-if="navIndex==4"></PoliciesRegulations>
      <JoinMember v-if="navIndex==5"></JoinMember>
      <About v-if="navIndex==6"></About>
    </div>
  </div>
</template>

<script>
import HeaderLayout from "../layout/HeaderLayout.vue";
import HomeComponent from "@/components/HomeComponent.vue";
import MessageList from "./MessageList.vue";
import GuideList from "./GuideList.vue";
import PoliciesRegulations from "./PoliciesRegulations.vue";
import JoinMember from "./JoinMember.vue";
import About from "./About.vue";

export default {
  name: "HomePage",
  components: { HeaderLayout, HomeComponent, MessageList, GuideList, PoliciesRegulations, About,JoinMember },
  data() {
    return {
      navIndex: 1,
      detailPageUrl: "",
      category: "",
    };
  },
  mounted() {
    this.updateNavIndex(); // 初始化 navIndex
  },
  watch: {
    '$route.query.idx': 'updateNavIndex' // 监听路由 idx 变化
  },
  methods: {
    updateNavIndex() {
      const idx = this.$route.query.idx;
      this.navIndex = idx ? parseInt(idx) : 1; // 默认值为 1
    }
  },
};
</script>

<style>
.component {
  min-height: 500px;
}
</style>